import React, { Component } from 'react'

import PrivateKey from '../components/PrivateKey/PrivateKey'
import AuthFooter from '../components/shared/AuthFooter/AuthFooter'

import requireWallet from '../hoc/requireWallet'
import requireUnlocked from '../hoc/requireUnlocked'
import { RECEIVE_WALLET_NAV } from '../constants/navigation'
import { extractWalletFromHistory } from '../util/wallet'

class PrivateKeyContainer extends Component {

  state = {
    privateKey: ''
  }

  componentDidMount() {
    this.setState({
      privateKey: extractPrivateKey(this.props.history)
    })
  }

  onClose = () => {
    const { history } = this.props
    history.replace(RECEIVE_WALLET_NAV)
  }

  render() {
    const { t } = this.props
    const { privateKey } = this.state
    return (
      <div className="main-container main-container--flex-column">
        <PrivateKey
          t={t}
          privateKey={privateKey}
          onClose={this.onClose}
        />
        <AuthFooter />
      </div>
    )
  }
}

export default requireWallet(requireUnlocked(PrivateKeyContainer))

function extractPrivateKey(history) {
  const wallet = extractWalletFromHistory(history)
  return wallet.privateKey || ''
}




// WEBPACK FOOTER //
// ./src/containers/PrivateKeyContainer.js